var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAdLogoVod = function SvgAdLogoVod(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 584 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 130.86h28.17V0H5.9C2.64 0 0 2.65 0 5.91v124.96-.01ZM90.28 75.12c3.01 3.07 4.86 7.26 4.86 11.89 0 9.39-7.61 17-17 17s-16.76-7.38-16.99-16.58H33.02c.23 24.72 20.33 44.7 45.11 44.7s45.12-20.2 45.12-45.12c0-12.4-5-23.62-13.1-31.78L90.26 75.12h.02Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.36 0h-85.9v26.87h85.9V0Z",
    fill: "#EC1F80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.46 26.87 66.67 53.66c-1.82 1.82-1.82 4.78 0 6.61l15.7 15.7 37.99-37.99V26.87H93.46Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M428.589 1.01v84.08c0 8.46-6.879 15.34-15.339 15.34h-14.911V1.1l-35.469-.09v99.42h-29.88V1.1l-35.47-.09v130.98l118.66.03c26.4-.01 47.88-21.5 47.88-47.91V1.09L428.589 1v.01ZM571.94 1H477.8v31.65h70.26v99.33h35.47V12.59c0-6.39-5.2-11.59-11.59-11.59ZM270.85 1.04 162.42 1c-.07 19.38-.03 74.51-.04 93.89 0 3.19-.66 3.82-3.96 3.79h-15.61v33.12c8.22-.08 18.84.07 27.06-.1 2.57-.05 5.2-.58 7.66-1.33 10.24-3.12 21.4-14.85 21.05-29.6V32.69h48.39v99.33h35.47V12.63c0-6.39-5.2-11.59-11.59-11.59Z",
    fill: "#F0F0F0"
  })));
};

export default SvgAdLogoVod;